module.exports = __webpack_public_path__ + "img/slide13.dfeca9eb.png";